



















































































































import { Vue, Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import DisplayMixin from '@/mixins/displayTitle'
import Editor from '@/components/Editor/editor.vue'

const classifyList = [
  {
    id: 1,
    name: '热门'
  },
  {
    id: 2,
    name: '流行'
  }
]
const langList = [
  {
    id: 1,
    name: '英文'
  },
  {
    id: 2,
    name: '中文(简体)'
  },
  {
    id: 3,
    name: '中文(繁体)'
  }
]

@Component({
  name: 'NewsAdd',
  components: {
    Editor
  }
})
export default class extends mixins(DisplayMixin) {
  params = {
    classifyId: '',
    appId: '',
    sort: '',
    publishDate: '',
    platform: '',
    url: '',
    poster: '',
    contentList: [
      {
        id: 1,
        lang: '英文',
        title: 'title111',
        author: 'huahu',
        text: '<p>正文 html</p>'
      },
      {
        id: 2,
        lang: '中文(简体)',
        title: '标题222',
        author: '胡华',
        text: '<p>正文 html</p>'
      },
      {
        id: 3,
        lang: '中文(繁体)',
        title: '标题333',
        author: '胡华',
        text: '<p>正文 html</p>'
      }
    ]
  }
  classifyList = classifyList
  langList = langList
  activeIndex = 0

  handleSwitch(i:number) {
    this.activeIndex = i
  }
  handeSubmit(type: 'save' | 'commit') {

  }
}
